export default __webpack_public_path__ + "static/media/logo.edba0c80.svg";